import { render, staticRenderFns } from "./menuSet.vue?vue&type=template&id=4c719ede&scoped=true&"
import script from "./menuSet.vue?vue&type=script&lang=js&"
export * from "./menuSet.vue?vue&type=script&lang=js&"
import style0 from "./menuSet.vue?vue&type=style&index=0&id=4c719ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c719ede",
  null
  
)

export default component.exports